import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f0798d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid mb-gutter" }
const _hoisted_2 = { class: "form-field form-field--gd grid__item" }
const _hoisted_3 = { class: "field-row" }
const _hoisted_4 = {
  "data-auto": "SARId-lbl",
  class: "label label--text label--inline"
}
const _hoisted_5 = { class: "form-field form-field--gd grid__item" }
const _hoisted_6 = { class: "field-row" }
const _hoisted_7 = {
  "data-auto": "SARSubmittedDate-lbl",
  class: "label label--text label--inline"
}
const _hoisted_8 = { class: "form-field form-field--gd grid__item" }
const _hoisted_9 = { class: "field-row" }
const _hoisted_10 = {
  "data-auto": "requestStatus-lbl",
  class: "label label--text label--inline"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-field form-field--gd grid__item" }
const _hoisted_13 = { class: "field-row" }
const _hoisted_14 = {
  "data-auto": "requestArrivalType-lbl",
  class: "label label--text label--inline"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-field form-field--gd grid__item" }
const _hoisted_17 = { class: "field-row" }
const _hoisted_18 = {
  "data-auto": "actualStartDate-lbl",
  class: "label label--text label--inline"
}
const _hoisted_19 = { class: "form-field form-field--gd grid__item" }
const _hoisted_20 = { class: "field-row" }
const _hoisted_21 = {
  "data-auto": "expectedCompletionDate-lbl",
  class: "label label--text label--inline"
}
const _hoisted_22 = { class: "form-field form-field--gd grid__item" }
const _hoisted_23 = { class: "field-row" }
const _hoisted_24 = {
  "data-auto": "actualCompletionDate-lbl",
  class: "label label--text label--inline"
}
const _hoisted_25 = { class: "form-field form-field--gd grid__item" }
const _hoisted_26 = { class: "field-row" }
const _hoisted_27 = {
  "data-auto": "assignTo-lbl",
  class: "label label--text label--inline"
}
const _hoisted_28 = { class: "padding--top" }
const _hoisted_29 = { class: "mb-gutter" }
const _hoisted_30 = {
  key: 1,
  class: "mb-gutter"
}
const _hoisted_31 = { class: "form-field form-field--gd" }
const _hoisted_32 = { class: "field-row" }
const _hoisted_33 = {
  "data-auto": "addNewTaskDesc-lbl",
  class: "label label--text label--inline"
}
const _hoisted_34 = { class: "grid grid--inline grid-align-items-right" }
const _hoisted_35 = { class: "grid__item form-field form-field--gd" }
const _hoisted_36 = { class: "field-row" }
const _hoisted_37 = { class: "grid__item form-field form-field--gd" }
const _hoisted_38 = { class: "field-row" }
const _hoisted_39 = {
  key: 2,
  class: "form-field gd-form-declaration div--background div--scroll"
}
const _hoisted_40 = { class: "field-row cusror--default" }
const _hoisted_41 = {
  ul: "",
  name: "HistoricalNotes",
  class: "label label--text label--inline"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field form-field--gd" }, null, -1))
const _hoisted_43 = { style: {"font-weight":"bold"} }
const _hoisted_44 = {
  class: "padding--top",
  style: {"display":"block"}
}
const _hoisted_45 = { class: "mb-gutter" }
const _hoisted_46 = { class: "form-field form-field--gd" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "form-field form-field--gd" }
const _hoisted_50 = { class: "field-row" }
const _hoisted_51 = {
  "data-auto": "addNewTaskDesc-lbl",
  class: "label label--text label--inline"
}
const _hoisted_52 = { class: "form-field form-field--gd" }
const _hoisted_53 = { class: "field-row" }
const _hoisted_54 = {
  "data-auto": "addNewTaskComment-lbl",
  class: "label label--text label--inline"
}
const _hoisted_55 = { class: "form-field form-field--gd" }
const _hoisted_56 = { class: "field-row" }
const _hoisted_57 = {
  "data-auto": "addNewTaskAsignee-lbl",
  class: "label label--text label--inline"
}
const _hoisted_58 = { class: "grid grid--inline grid-align-items-right" }
const _hoisted_59 = { class: "grid__item form-field form-field--gd" }
const _hoisted_60 = { class: "field-row" }
const _hoisted_61 = { class: "grid__item form-field form-field--gd" }
const _hoisted_62 = { class: "field-row" }
const _hoisted_63 = { class: "field-row cusror--default" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["colspan"]
const _hoisted_67 = { class: "grid editable-grid" }
const _hoisted_68 = { class: "form-field form-field--gd grid__item" }
const _hoisted_69 = { class: "field-row" }
const _hoisted_70 = {
  "data-auto": "requestStatusEdit-lbl",
  class: "label label--text label--inline"
}
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "form-field form-field--gd grid__item" }
const _hoisted_74 = { class: "field-row" }
const _hoisted_75 = {
  "data-auto": "descriptionEdit-lbl",
  class: "label label--text label--inline"
}
const _hoisted_76 = { class: "form-field form-field--gd grid__item" }
const _hoisted_77 = { class: "field-row" }
const _hoisted_78 = {
  "data-auto": "commentEdit-lbl",
  class: "label label--text label--inline"
}
const _hoisted_79 = { class: "form-field form-field--gd grid__item" }
const _hoisted_80 = { class: "field-row" }
const _hoisted_81 = {
  "data-auto": "assigneeEdit-lbl",
  class: "label label--text label--inline"
}
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "mb-gutter" }
const _hoisted_84 = { class: "grid mb-gutter" }
const _hoisted_85 = { class: "form-field form-field--gd grid__item" }
const _hoisted_86 = { class: "field-row" }
const _hoisted_87 = {
  "data-auto": "SARConsentId-lbl",
  class: "label label--text label--inline"
}
const _hoisted_88 = { class: "tooltip-icon tooltip-icon-label" }
const _hoisted_89 = { "data-auto": "ConsentHistoryInfo-btn" }
const _hoisted_90 = { class: "form-field form-field--gd grid__item" }
const _hoisted_91 = { class: "field-row" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "field-row cusror--default" }
const _hoisted_94 = {
  type: "button",
  class: "button button--alt button--block"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_96 = {
  "data-auto": "assignTo-lbl",
  class: "label label--text label--inline"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_fileupload = _resolveComponent("v-fileupload")!
  const _component_v_fileattachment = _resolveComponent("v-fileattachment")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_export_excel = _resolveComponent("export-excel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("labeltext.reportRequestID")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initModel.SARID) = $event)),
            name: "SARID",
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.initModel.SARID]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("labeltext.SARSubmittedDate")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sarLegalMgmt.SARCreatedDT) = $event)),
            name: "SARSubmittedDate",
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.sarLegalMgmt.SARCreatedDT]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("labeltext.requestStatus")), 1),
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitChangesToParent && _ctx.emitChangesToParent(...args))),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sarLegalMgmt.RequestStatusID) = $event)),
            name: "RequestStatusID",
            class: "fixedWidth"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.RequestStatusList, (RequestStatusVal, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: RequestStatusVal.RequestStatusID,
                key: index
              }, _toDisplayString(_ctx.getDDLTranslatedValue(RequestStatusVal.Resource_Key)), 9, _hoisted_11))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.sarLegalMgmt.RequestStatusID]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("labeltext.requestArrivalType")), 1),
          _withDirectives(_createElementVNode("select", {
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitChangesToParent && _ctx.emitChangesToParent(...args))),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sarLegalMgmt.RequestArrivalTypeID) = $event)),
            name: "RequestArrivalTypeID",
            class: "fixedWidth"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.RequestArrivalTypeList, (RequestArrivalType, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: RequestArrivalType.RequestArrivalTypeID,
                key: index
              }, _toDisplayString(_ctx.getDDLTranslatedValue(RequestArrivalType.Resource_Key)), 9, _hoisted_15))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.sarLegalMgmt.RequestArrivalTypeID]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("labeltext.actualStartDate")), 1),
          _createVNode(_component_date_picker, {
            "model-value": _ctx.sarLegalMgmt.ActualStartDT,
            "onUpdate:modelValue": _ctx.actualStartDTChanged,
            locale: _ctx.initModel.datepickerLang,
            "enable-time-picker": false,
            format: _ctx.dateFormat,
            "auto-apply": "",
            "hide-input-icon": "",
            name: "ActualStartDate"
          }, null, 8, ["model-value", "onUpdate:modelValue", "locale", "format"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("labeltext.expectedCompletionDate")), 1),
          _createVNode(_component_date_picker, {
            "model-value": _ctx.sarLegalMgmt.ExpectedCompletionDT,
            "onUpdate:modelValue": _ctx.expectedCompletionDTChanged,
            locale: _ctx.initModel.datepickerLang,
            "enable-time-picker": false,
            format: _ctx.dateFormat,
            "auto-apply": "",
            "hide-input-icon": "",
            name: "ExpectedCompletionDT"
          }, null, 8, ["model-value", "onUpdate:modelValue", "locale", "format"])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("labeltext.actualCompletionDate")), 1),
          _createVNode(_component_date_picker, {
            "model-value": _ctx.sarLegalMgmt.ActualCompletionDT,
            "onUpdate:modelValue": _ctx.actualCompletionDTChanged,
            locale: _ctx.initModel.datepickerLang,
            "enable-time-picker": false,
            format: _ctx.dateFormat,
            "auto-apply": "",
            "hide-input-icon": "",
            name: "ActualCompletionDT"
          }, null, 8, ["model-value", "onUpdate:modelValue", "locale", "format"])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("labeltext.assignTo")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.emitChangesToParent && _ctx.emitChangesToParent(...args))),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sarLegalMgmt.Assignee) = $event)),
            name: "AssignTo",
            maxlength: "200"
          }, null, 544), [
            [_vModelText, _ctx.sarLegalMgmt.Assignee]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_fileupload, {
        initModel: _ctx.initModel,
        sarMgmtModel: _ctx.sarLegalMgmt,
        onShowValidationMessage: _ctx.showErrorMessageForFileUploadFromChild
      }, null, 8, ["initModel", "sarMgmtModel", "onShowValidationMessage"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_fileattachment, {
        sarMgmtModel: _ctx.sarLegalMgmt,
        onEmmitedFileDetailsLegal: _ctx.downloadFileForLegal
      }, null, 8, ["sarMgmtModel", "onEmmitedFileDetailsLegal"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        (!_ctx.showAddNoteSection)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mb-gutter button addnotes-btn",
              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.expandNotes && _ctx.expandNotes(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.$t("labeltext.sarmgmtAddNote")), 1))
          : _createCommentVNode("", true),
        (_ctx.showAddNoteSection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("labeltext.notes")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sarLegalNotes.Notes) = $event)),
                    name: "addNotes",
                    maxlength: "3000"
                  }, null, 512), [
                    [_vModelText, _ctx.sarLegalNotes.Notes]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, [
                    _createElementVNode("button", {
                      class: "button",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNotesEvent && _ctx.addNotesEvent(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t("labeltext.sarmgmtAddNotesButton")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, [
                    _createElementVNode("button", {
                      class: "button button--alt",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelNotes && _ctx.cancelNotes(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t("labeltext.sarmgmtCancelNotes")), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.sarLegalMgmt.HistoricalNotes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sarLegalMgmt.HistoricalNotes, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-field form-field--gd div--padding",
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_43, _toDisplayString(item.NotesCreatedBy) + " " + _toDisplayString(_ctx.renderHistoricalNotes()) + " - " + _toDisplayString(item.NotesCreatedDate.replace("T", " ")) + " : ", 1),
                        _createElementVNode("p", null, _toDisplayString(item.Notes), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            (!_ctx.showCreateTaskSection)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mb-gutter button addnotes-btn",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.expandCreateTasks && _ctx.expandCreateTasks(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t("labeltext.sarmgmtAddTask")), 1))
              : _createCommentVNode("", true),
            (_ctx.showCreateTaskSection == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, [
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("labeltext.Description")), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sarLegalTask.Description) = $event)),
                          name: "addNewTaskDesc",
                          maxlength: "1000"
                        }, null, 512), [
                          [_vModelText, _ctx.sarLegalTask.Description]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, [
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("labeltext.Comment")), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sarLegalTask.Comment) = $event)),
                          name: "addNewTaskComment",
                          maxlength: "3000"
                        }, null, 512), [
                          [_vModelText, _ctx.sarLegalTask.Comment]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("labeltext.Assignee")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sarLegalTask.Assignee) = $event)),
                          name: "addNewTaskAsignee",
                          maxlength: "100"
                        }, null, 512), [
                          [_vModelText, _ctx.sarLegalTask.Assignee]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("label", _hoisted_60, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button",
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addNewTask && _ctx.addNewTask(...args)))
                        }, _toDisplayString(_ctx.$t("labeltext.sarmgmtAddNotesButton")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("label", _hoisted_62, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button button--alt",
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.cancelTask && _ctx.cancelTask(...args)))
                        }, _toDisplayString(_ctx.$t("labeltext.sarmgmtCancelNotes")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_63, [
                (_ctx.showtaskgrid)
                  ? (_openBlock(), _createBlock(_component_v_data_table, {
                      key: 0,
                      headers: _ctx.headers,
                      items: _ctx.sargridsearchTaskResultFromParent,
                      "items-per-page": _ctx.itemsPerPage,
                      "items-per-page-options": _ctx.footerProps.itemsPerPageOptions,
                      "footer-props": _ctx.footerProps,
                      expanded: _ctx.expanded,
                      "onUpdate:expanded": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.expanded) = $event)),
                      ref: "taskTable",
                      "item-key": "SARManagementTaskID",
                      "item-value": "SARManagementTaskID",
                      "fixed-header": "",
                      "show-expand": "",
                      dense: "",
                      class: "table-styled mb-gutter"
                    }, {
                      [`item.SARManagementTaskID`]: _withCtx(({ item }) => [
                        _createElementVNode("button", {
                          class: "glyphicon glyphicon-eye-open",
                          onClick: _withModifiers(($event: any) => (_ctx.deleteTask(item.SARManagementTaskID)), ["prevent"])
                        }, " X ", 8, _hoisted_64)
                      ]),
                      "item.data-table-expand": _withCtx(({
                      internalItem,
                      item,
                      toggleExpand,
                    }) => [
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            ref: "toggleButton",
                            onClick: _withModifiers(($event: any) => {
                          _ctx.setEditorProperties(item);
                          toggleExpand(internalItem);
                        }, ["prevent"]),
                            class: "button taskedit-btn"
                          }, _toDisplayString(_ctx.$t("labeltext.taskEdit")), 9, _hoisted_65)
                        ])
                      ]),
                      "expanded-row": _withCtx(({ columns, item }) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            colspan: columns.length,
                            style: {"padding-top":"12px","padding-bottom":"12px"}
                          }, [
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("label", _hoisted_69, [
                                  _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t("labeltext.taskStatus")), 1),
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((item.TaskStatusID) = $event),
                                    name: "RequestStatusID",
                                    class: "fixedWidth"
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.TaskStatusList, (TaskStatusVal, index) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: TaskStatusVal.TaskStatusID,
                                        key: index
                                      }, _toDisplayString(_ctx.getDDLTranslatedValue(
                                      TaskStatusVal.Resource_Key
                                    )), 9, _hoisted_72))
                                    }), 128))
                                  ], 8, _hoisted_71), [
                                    [_vModelSelect, item.TaskStatusID]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("label", _hoisted_74, [
                                  _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t("labeltext.Description")), 1),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.description) = $event)),
                                    maxlength: "1000"
                                  }, null, 512), [
                                    [_vModelText, _ctx.description]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("label", _hoisted_77, [
                                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("labeltext.Comment")), 1),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.comment) = $event)),
                                    rows: "5",
                                    maxlength: "3000"
                                  }, null, 512), [
                                    [_vModelText, _ctx.comment]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("label", _hoisted_80, [
                                  _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t("labeltext.Assignee")), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.assignee) = $event)),
                                    maxlength: "100"
                                  }, null, 512), [
                                    [_vModelText, _ctx.assignee]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "button button--align--right",
                              onClick: _withModifiers(($event: any) => (_ctx.updateTaskDetails(item)), ["prevent"])
                            }, _toDisplayString(_ctx.$t("labeltext.taskSave")), 9, _hoisted_82)
                          ], 8, _hoisted_66)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["headers", "items", "items-per-page", "items-per-page-options", "footer-props", "expanded"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labeltext.consentMarketingTextHeader")), 1)
      ]),
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("label", _hoisted_86, [
            _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.$t("labeltext.consentCustomerId")), 1),
            _createElementVNode("span", _hoisted_88, [
              _createElementVNode("i", _hoisted_89, [
                _createTextVNode("i "),
                _createVNode(_component_v_tooltip, {
                  activator: "parent",
                  location: "bottom",
                  width: "320px",
                  contained: true,
                  "open-on-click": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labeltext.consentTooltipCustRef", {
                      brandPlcName1: _ctx.initModel.brandPlcName,
                      brandPlcName2: _ctx.initModel.brandPlcName,
                    })), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sarLegalMgmt.ConsentId) = $event)),
              name: "SARConsentID",
              onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.emitChangesForConsentHistory && _ctx.emitChangesForConsentHistory(...args))),
              maxlength: "100"
            }, null, 544), [
              [_vModelText, _ctx.sarLegalMgmt.ConsentId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("label", _hoisted_91, [
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.getConsentEvent && _ctx.getConsentEvent(...args)))
            }, _toDisplayString(_ctx.$t("labeltext.consentHistoryButton")), 1)
          ])
        ]),
        (_ctx.showConsentHstryGrid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              _createElementVNode("label", _hoisted_93, [
                _createVNode(_component_v_data_table, {
                  class: "table-styled mb-gutter",
                  items: _ctx.sarConsentHistoryDataModel,
                  "items-per-page": _ctx.itemsPerPage,
                  "items-per-page-options": _ctx.footerProps.itemsPerPageOptions,
                  "footer-props": _ctx.footerProps,
                  "item-key": "CustomerId",
                  "fixed-header": "",
                  "show-expand": "",
                  dense: ""
                }, null, 8, ["items", "items-per-page", "items-per-page-options", "footer-props"])
              ]),
              _createVNode(_component_export_excel, {
                data: _ctx.sarConsentHistoryDataModel,
                fields: _ctx.consentHistoryDownloadOptions.json_fields,
                type: "csv",
                name: _ctx.translate('labeltext.consentHstryfileDownloadName')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_94, _toDisplayString(_ctx.$t("labeltext.reportDownload")), 1)
                ]),
                _: 1
              }, 8, ["data", "fields", "name"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_95,
      _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t("labeltext.originalSARData")), 1),
      _hoisted_97
    ])
  ]))
}